import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { SIGNIN_USER, SIGNOUT_USER, SIGNIN_USER_SUCCESS } from 'constants/ActionTypes';
import { showAuthMessage, userSignInSuccess, userSignOutSuccess } from 'actions/Auth';

function* signOut() {
	localStorage.removeItem('authToken');
	localStorage.removeItem('tokenExpireTime');
}

export function* signOutUser() {
	yield takeEvery(SIGNOUT_USER, signOut);
}

function* saveToken({ payload }) {
	localStorage.setItem('authToken', payload.token);
	if (payload.tokenExpireTime) localStorage.setItem('tokenExpireTime', payload.tokenExpireTime);
}

export function* signInUserSuccess() {
	yield takeEvery(SIGNIN_USER_SUCCESS, saveToken);
}

export default function* rootSaga() {
	yield all([fork(signOutUser), fork(signInUserSuccess)]);
}



// WEBPACK FOOTER //
// ./sagas/Auth.js